import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  titleWrapper: {
    textAlign: 'center',
    margin: '20px',
  },
}));
